import React from 'react';
import { Box, Typography } from '@material-ui/core';
import {
    InvisibleAccordion,
    InvisibleAccordionSummary,
    InvisibleAccordionDetails
} from './InvisibleAccordion';
import { Alert } from '@material-ui/lab';
import { InfoOutlinedIcon } from '../../../icons';
import ReadonlyEditor from '../../../components/drafteditor/components/ReadonlyEditor';

export const CancellationWindowText = ({ cancellation_window = 0 }) => {
    return (
        <p style={{ whiteSpace: 'pre-line' }}>
            Cancellations made {cancellation_window} hour
            {cancellation_window > 1 ? 's' : ''} or more in advance of the activity&apos;s start
            date will receive a refund. Cancellations made within {cancellation_window} hour
            {cancellation_window > 1 ? 's' : ''} will not receive a refund.
        </p>
    );
};

const ActivityCancellationContent = ({
    name = '',
    terms = '',
    cancellation_window = 0,
    cancellation_info = ''
}) => {
    return (
        <Alert severity="info" style={{ marginBottom: '5px' }}>
            <h4>{name}</h4>
            <CancellationWindowText cancellation_window={cancellation_window} />
            {cancellation_info && <ReadonlyEditor value={cancellation_info} />}
            {terms && (
                <p>
                    <a
                        href={terms}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#1976d2', textDecoration: 'underline' }}
                    >
                        Activity terms and conditions
                    </a>
                </p>
            )}
        </Alert>
    );
};

const CancellationPolicy = ({ cartItems }) => {
    const uniqueActivities = cartItems
        .map(item => item.activity)
        .reduce((unique, item) => {
            if (!unique.some(act => act.id === item.id)) {
                unique.push({
                    id: item.id,
                    name: item.name,
                    cancellation_window: item.cancellation_window || 0,
                    terms: item.extra_info?.terms || '',
                    cancellation_info: item.extra_info?.cancellation_info || ''
                });
            }
            return unique;
        }, []);

    return (
        <Box
            style={{
                display: 'flex',
                maxWidth: '800px'
            }}
        >
            <InvisibleAccordion>
                <InvisibleAccordionSummary aria-controls="panel1-content" id="panel1-header">
                    <Box display="flex" alignItems="center" gridGap="8px">
                        <InfoOutlinedIcon color="inherit" />
                        <Typography
                            style={{
                                fontWeight: 'bold',
                                textDecoration: 'underline'
                            }}
                        >
                            Cancellation Policy can differ per activity, click to view details
                        </Typography>
                    </Box>
                </InvisibleAccordionSummary>
                <InvisibleAccordionDetails
                    style={{ display: 'block', padding: '20px', backgroundColor: '#f9f9f9' }}
                >
                    <Typography
                        style={{
                            marginBottom: '10px'
                        }}
                    >
                        <strong>Note:</strong> The cancellation policy below is specific to the
                        activity listed. Please review all activities in your cart for their
                        individual cancellation policies.
                    </Typography>
                    {uniqueActivities.map(activity => (
                        <Box key={activity.id} mb={2}>
                            <ActivityCancellationContent
                                name={activity.name}
                                terms={activity.terms}
                                cancellation_window={activity.cancellation_window}
                                cancellation_info={activity.cancellation_info}
                            />
                        </Box>
                    ))}
                </InvisibleAccordionDetails>
            </InvisibleAccordion>
        </Box>
    );
};

export default CancellationPolicy;
